import React, { PureComponent } from 'react';

import { InputField } from '..';

import styles from './styles.scss';

export default class ClipboardInput extends PureComponent {
  state = {
    copyState: null
  };

  copyToClipboard = () => {
    try {
      const successful = document.execCommand('copy');

      if (!successful) {
        throw new Error('Failed to copy to clipboard');
      }

      this.setState({
        copyState: 'success'
      });

      // Reset the button after a few seconds
      setTimeout(() => this.setState({
        copyState: null
      }), 3000);
    } catch (err) {
      // TODO: update button text/color on failure
    }
  };

  render() {
    const { copyState } = this.state;
    const { label, value, hint, labelClass } = this.props;

    return (
      <InputField
        buttonText={ copyState === 'success' ? 'Copied!' : 'Copy' }
        className={ styles.clipboardInput }
        focusOnClick
        handleSubmit={ this.copyToClipboard }
        labelClass={ labelClass }
        label={ label }
        hint={ hint }
        readOnly
        value={ value }
      />
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/ClipboardInput/index.jsx